import type { IconData } from '@stacksjs/iconify-core'

export const internetNetworkUpload: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13.715 18.28h4.57v1.53h-4.57Zm0-3.04h4.57v1.52h-4.57Zm15.24 10.66h1.52v3.05h-1.52Zm-1.52-3.04h1.52v3.04h-1.52Zm-24.38 6.09v1.53h1.52V32h22.86v-1.52h1.52v-1.53zm18.28-19.81h4.57v1.53h-4.57Zm-7.62 16.76h4.57v1.53h-4.57Zm0-12.19h4.57V6.09h3.05V4.57h-1.52V3.05h-1.53V1.52h-1.52V0h-1.52v1.52h-1.53v1.53h-1.52v1.52h-1.53v1.52h3.05zm-7.62-4.57h4.57v1.53h-4.57Z\"/><path fill=\"currentColor\" d=\"M27.435 22.86V10.67h-1.53v10.66H6.095V10.67h-1.52v12.19zm-24.38 0h1.52v3.04h-1.52Zm-1.53 3.04h1.53v3.05h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default internetNetworkUpload
